export const SAVE_ALL_CUSTOMERS = 'SAVE_ALL_CUSTOMERS'